import ClientBalanceCard from '@/components/client/client-balance-card';
import type { IBalance } from '@/entities/balance.entity';
import { WalletIcon } from 'lucide-react';

interface ClientBalancesListProps {
	balances: IBalance[];
	onCopy: (text: string) => void;
	isSearching?: boolean;
}

export default function ClientBalancesList({ balances, onCopy, isSearching = false }: ClientBalancesListProps) {
	if (!balances.length) {
		return (
			<div className='flex flex-col items-center justify-center mt-10 gap-2 px-4 text-center'>
				<WalletIcon size={24} className='text-muted-foreground/40' />
				<p className='text-sm text-muted-foreground'>
					{isSearching ? 'Ничего не найдено' : 'Сообщений с балансом нет'}
				</p>
			</div>
		);
	}

	return (
		<div className='flex flex-col gap-1.5 px-2'>
			{balances.map(balance => (
				<ClientBalanceCard key={balance.id} balance={balance} onCopy={onCopy} />
			))}
		</div>
	);
}
